
import axiosInstance from "./AxiosConfig";



export function registerUser(user) {

 return axiosInstance({
    method: 'post',
    url: 'Auth/register',
    data: user

  }).then(function (response) {
    
    if (response.status === 200) {
      return ({ boolean: true, message: "User created correctly. You can login now." })
    }
    else {
      return ({ boolean: false, message: "Something went wrong." })
    }
  }).catch(function (error) {

    console.error(error);
    return { boolean: false, message: "An error occurred during registration." };
  });

}

export async function loginUser(credentials) {
  try {
    const response = await axiosInstance({
      method: 'post',
      url: "Auth/login",
      data: credentials
    });

    if (response.data.accessToken) {
      localStorage.setItem("accessToken", response.data.accessToken);
      localStorage.setItem("refreshToken", response.data.refreshToken);
      return true;
    } else {
      return false;
    }
  } catch (error) {

    if(error.response.status === 401){
      return ({boolean: false, message: "Wrong credentials."});
    }
    console.log("Error during login:", error);
    return false;
  }
}







export async function checkTokenIfActive() {
    try {
      const response = await axiosInstance({
        method: 'post',
        url: 'Auth/checkToken',
      });
  
      return response.data;
    } catch (error) {
      if (error.response) {
        // Check for specific error status codes
        if (error.response.status === 401) {
          try {
            const tryRefresh = await refreshToken();
  
            if (tryRefresh) {
              if (tryRefresh.response.status === 404) {
                console.log("Error 404: Not Found");

              } else if (tryRefresh.response.status === 200) {
                console.log('Token refresh success');

              }
            }
  
            return false;
          } catch (refreshError) {
            console.error("Error during token refresh:", refreshError);
            return false;
          }
        }
      } else {
        console.error("Error in checkTokenIfActive:", error);
        return false;
      }
    }
  }

export async function addWeightEntry(entry){

try{
   const response = await axiosInstance({
      method: 'put',
      url: "User/addWeightEntry",
      data: entry
   });

   if(response.status === 200){
    return ({boolean: true, message: "Weight added correctly."})
   }
  }
  catch(error){
    console.log(error);
    return ({boolean: false, message: "Something went wrong."})
  }


   
}

export async function deleteEntry(date){

  try{
     const response = await axiosInstance({
        method: 'delete',
        url: "User/deleteWeightEntry",
        data: date
     });
  
     if(response.status === 200){
      return ({boolean: true, message: "Weight deleted correctly."})
     }
    }
    catch(error){
      console.log(error);
      return ({boolean: false, message: "Something went wrong."})
    }
  
  
     
  }



export function getWeightEntries(){
    return new Promise((resolve) => {
      
    axiosInstance({
        method: 'get',
        url: "User/getWeightEntries",
    }).then (function (response) {
        resolve(response);
        
    }).catch(function (error) {
        if (error.response.status === 401){
            console.log("Error 401: Unauthorized")
            return false;
        }
    })

})
}


export function getUserInfo() {
  return new Promise((resolve) => {
      
    axiosInstance({
        method: 'get',
        url: "User/getUserInfo",
    }).then (function (response) {
        resolve(response);
        
    }).catch(function (error) {
        if (error.response.status === 401){
            console.log("Error 401: Unauthorized")
            return false;
        }
    })

})
}

export function refreshToken() {

    let refreshToken = localStorage.getItem('refreshToken');
    axiosInstance({
        method: 'post',
        url: "Auth/refresh",
        data: {refreshToken: refreshToken}
    }).then (function (response){
        if(response.status === 200){
            localStorage.setItem("accessToken", response.data.accessToken),
            localStorage.setItem("refreshToken")
        }
        return response;
    }).catch(error => {
        return error;
    })
}

const UserService = {
    registerUser,
    loginUser
}

export async function logout() {

  try{

  
  const response = await axiosInstance({
    method: 'delete',
    url: "Auth/logout",
  });

  if(response.status === 204){
    localStorage.clear();
    return response;
  }
}
catch (error) {

  if(error.response.status === 401){
    return ({boolean: false, message: "Wrong credentials."});
  }
  console.log("Error during login:", error);
  return false;
}
}



export default  UserService;